//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Nav from "../Az/Mobile/Nav";
//Install
import Menu from "../Az/Header/Menu";
//Install
import Logo from "../Az/Mobile/Logo";
//Install
import Close from "../Az/Mobile/Close";
//Install
import Brand from "../Az/Header/Brand";
//Install
import World from "../Az/Mobile/World";
//Install
import Submenu from "../Az/Mobile/Submenu";
//Install
import Language from "../Az/Header/Language";
//Install
import Worldwide from "../Az/Mobile/Worldwide";

//Element
class Header extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("header", { className: "S6pt64 C96Q4r pEO064 a527eB h6327b" },
            //Element
            React.createElement("nav", { className: "S6pt64 C96Q4r pEO064 a527eB j95v4n" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement(Brand, {})
                        ),
                        //Element
                        React.createElement(Col, { md: 7 },
                            //Element
                            React.createElement(Menu, {})
                        ),
                        //Element
                        React.createElement(Col, { md: 2 },
                            //Element
                            React.createElement(Language, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement("nav", { className: "S6pt64 C96Q4r pEO064 a527eB j6m241" },
                //Element
                React.createElement(Container, {},
                    //Element
                    React.createElement(Row, {},
                        //Element
                        React.createElement(Col, { md: 3 },
                            //Element
                            React.createElement(Nav, {}),
                            //Element
                            React.createElement(Close, {})
                        ),
                        //Element
                        React.createElement(Col, { md: 5 },
                            //Element
                            React.createElement(Logo, {})
                        ),
                        //Element
                        React.createElement(Col, { md: 4 },
                            //Element
                            React.createElement(World, {})
                        )
                    )
                )
            ),
            //Element
            React.createElement(Worldwide, {}),
            //Element
            React.createElement(Submenu, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Header;